// src/pages/OrderProcessing.js
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PaymentProcessing from "../components/common/PaymentProcessing";

const OrderProcessing = () => {
  const [params] = useSearchParams();
  const orderId = params.get("orderId");
  const navigate = useNavigate();

  useEffect(() => {
    if (!orderId) return;

    // Allow the loader to remain visible while backend/order page loads
    const timer = setTimeout(() => {
      navigate(`/order-success/${orderId}`, { replace: true });
    }, 1000); // small UX pause (not required, but feels smoother)

    return () => clearTimeout(timer);
  }, [orderId]);

  return <PaymentProcessing message="Finalizing your order..." />;
};

export default OrderProcessing;
